export default __webpack_public_path__ + "static/media/Group_8414.3687b32d.svg";